import { Component, Input, OnInit, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faLock, faTruck, faCreditCard, faComment, faBookmark, faSearch, faHand, faWallet, faGavel, faTicket } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { AuthService } from '../../../services/authentication/auth.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-account-menu',
  imports: [FontAwesomeModule],
  templateUrl: './account-menu.component.html',
  styleUrl: './account-menu.component.scss'
})

export class AccountMenuComponent implements OnInit {
  protected icons = {
    faUser: faUser,
    faLock: faLock,
    faTruck: faTruck,
    faCreditCard: faCreditCard,
    faComment: faComment,
    faBookmark: faBookmark,
    faSearch: faSearch,
    faHand: faHand,
    faWallet: faWallet,
    faGavel: faGavel,
    faTicket: faTicket
  }

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
    
  isAuthenticated = this.oidcSecurityService.authenticated;  
  authSubscription!: Subscription;

  @Input() id: number | null = null;
  pageRoute = "my-account";

  public menuElements: { route: string, title: string, text: string, icon: IconDefinition }[] = [];

  constructor(private bidderCommunityMenuService: BidderCommunityMenuService) { }


  ngOnInit() {
    setTimeout(() => {
      this.bidderCommunityMenuService.setPageData(
        {
          id: this.id!,
          pageName: "My Account",
          pageRoute: this.pageRoute
        }
      )
      
      if (typeof window !== 'undefined') {
        window.onpageshow = function (event) {
          if (event.persisted) {
            window.location.reload();
          }
        };
        if (!this.isAuthenticated().isAuthenticated) {
          window.open(environment.mediaUrl, '_self');
          return;
        }else{
          this.initMenuElements();
        }
      }

      this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
        if (isAuth) {        
          this.initMenuElements();
        } else {
            if (typeof window !== 'undefined') {
              window.open(environment.mediaUrl, '_self');
            }
            return;
        }
      });
    },100);
  }

  initMenuElements() {
    this.menuElements = [
      { route: this.pageRoute + "/account-info/" , title: "Account", text: "Manage your personal details, update contact information, and customize your public nickname for bid history visibility.", icon: this.icons.faUser },
      { route: this.pageRoute + "/password/" , title: "Password", text: "Change your password anytime to maintain account security.", icon: this.icons.faLock },
      { route: this.pageRoute + "/shipping-address/" , title: "Shipping Address", text: "Save and update shipping addresses to use during purchases.", icon: this.icons.faTruck },
      { route: this.pageRoute + "/credit-cards/" , title: "Credit Cards", text: "Add, edit, or remove your saved credit cards for faster checkout.", icon: this.icons.faCreditCard },
      { route: this.pageRoute + "/text-messages/" , title: "Text Messages", text: "Manage SMS alerts for outbids and important updates, and set quiet hours.", icon: this.icons.faComment },
      { route: this.pageRoute + "/favorites/" , title: "Favorites", text: "Keep your favorited items in one place, with key details like time left and current price.", icon: this.icons.faBookmark },
      { route: this.pageRoute + "/my-searches/" , title: "My Searches", text: "Turn saved search alerts on or off, and manage how you receive updates about them.", icon: this.icons.faSearch },
      { route: this.pageRoute + "/my-bids/" , title: "My Bids", text: "Track all your bidding activity and check the status of past bids.", icon: this.icons.faHand },
      { route: this.pageRoute + "/my-purchases/" , title: "My Purchases", text: "View purchase history with payment details and summaries.", icon: this.icons.faWallet },
      { route: this.pageRoute + "/my-auctions/" , title: "My Auctions", text: "Saved Auctions lets you keep track of auctions you want to follow.", icon: this.icons.faGavel },
      { route: this.pageRoute + "/my-tickets/" , title: "My Tickets", text: "View and manage your purchased tickets, transfer tickets, and respond to event questions.", icon: this.icons.faTicket },
    ];
  }



}
